/** @format */

import { TableBody, TableCell, TableFooter, TableHead, TableRow, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditButton from '../../../components/Buttons/EditButton';
import PaperedTable from '../../../components/Table/PaperedTable';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import I18n from '../../../components/Translate/I18n';
import { configDefault } from '../../../core/config';
import { history } from '../../../core/history';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { store } from '../../../core/store';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { tariffConstants } from '../../../modules/tariffs/actions';
import { TariffReducersType, tariffsReducers } from '../../../modules/tariffs/reducers';
import Pager from '../../../components/Adescom/Pager';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import DeleteButton from '../../../components/Buttons/DeleteButton';
import { AlertDialog } from '../../lib/dialog/AlertDialog';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import TemplateButton from '../../../components/Buttons/TemplateButton';
import { Cash100 } from 'mdi-material-ui';

store.injectReducer('tariffsReducers', tariffsReducers);

const TariffList = (props: { classes: any }): React.ReactElement => {
    const classes = props.classes;
    const dispatch = useDispatch();

    const URI = '/tariffs';

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableStickyCommand = { root: classes.tableStickyCommand };

    const [filters, setFilters] = useState<Array<Filter>>([]);
    const [orders, setOrders] = useState<Array<Order>>([]);
    const [selectedTariffId, setSelectedTariffId] = useState<null | number>(null);

    const editTariff = (param: any): void => history.push(FormGeneralHelper.getRouteUrl(`/tariff-edit/${param.id}`));
    const addTariff = (): void => history.push(FormGeneralHelper.getRouteUrl('/tariff-add'));

    const { collections } = useSelector((state: { tariffsReducers: TariffReducersType }) => {
        return state.tariffsReducers;
    });

    const paginationCallbackFunction = (uri?: string | null): void => {
        if (!uri) {
            uri = FormGeneralHelper.getPath(URI, configDefault.PLATFORM_API_PREFIX);
        }

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(FormGeneralHelper.getByUri(uri), tariffConstants.LIST, filters, orders, (data: any) => {}, {
            propagateDataToCallback: false,
            dispatchAfterCallback: true,
        });
    };

    const deleteTariff = (params: { id: number }): void => {
        setSelectedTariffId(params.id);
    };

    const confirmDelete = (): void => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.deleteCall(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(`${URI}/${selectedTariffId}`, configDefault.PLATFORM_API_PREFIX)),
            tariffConstants.DELETE,
            (data: any) => {
                setSelectedTariffId(null);
                if (!data) {
                    NotificationHelper.notifyError('tariffs:notify.tariff_delete_error', dispatch);
                } else {
                    NotificationHelper.notifySuccess('tariffs:notify.tariff_delete_success', dispatch);
                    paginationCallbackFunction();
                }
            },
            {
                dispatchAfterCallback: false,
            }
        );
    };

    //TODO: Add somehow customerId to filter
    useEffect(() => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(URI, configDefault.PLATFORM_API_PREFIX)),
            tariffConstants.LIST,
            [],
            [],
            (data: any) => {},
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    }, [dispatch]);

    const editPricelist = (param: any): void => history.push(FormGeneralHelper.getRouteUrl(`/linear-billing-list/${param.id}`));

    return (
        <GridContainer>
            <GridItem xs={12} md={12} lg={12}>
                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_POST) && (
                    <CustomTextButtom size={'lg'} color="primary" label={'tariffs:button.add_new_tariff'} callback={addTariff} callbackParam={{}} />
                )}
                <PaperedTable>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableStickyCommand} padding="none" align="left">
                                <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell textAlign="left" title="tariffs:t.tariff" />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell textAlign="left" title="tariffs:type.type" />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collections &&
                            collections['hydra:member'].map((el: any) => {
                                return (
                                    <TableRow key={el.id}>
                                        <TableCell classes={tableCellRoot} align="left">
                                            {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                <EditButton
                                                    tooltipTitle="tariffs:button.edit_tariff"
                                                    callback={editTariff}
                                                    callbackParam={{ id: el.id }}
                                                />
                                            )}
                                            {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_DELETE) && (
                                                <DeleteButton
                                                    tooltipTitle="tariffs:button.delete_tariff"
                                                    callback={deleteTariff}
                                                    callbackParam={{ id: el.id }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} align="left">
                                            {el.tariffName}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} align="left">
                                            {<I18n trans={`tariffs:type.type_${el.type}`} />}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell classes={tableCellRoot} colSpan={3}>
                                {collections && collections['hydra:view'] && (
                                    <Pager callback={paginationCallbackFunction} views={collections['hydra:view']} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </PaperedTable>
                <AlertDialog
                    open={!!selectedTariffId}
                    titleDialog="tariffs:notify.confirm_delete_title"
                    displayMessage="tariffs:notify.confirm_delete_message"
                    closeCallback={(): void => setSelectedTariffId(null)}
                    confirmCallback={confirmDelete}
                />
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(TariffList);
